// extracted by mini-css-extract-plugin
export default {"container":"AuthLinkGroup_container__-Bc7J","linkTitle":"AuthLinkGroup_linkTitle__PEgCQ","link":"AuthLinkGroup_link__jsO-U"};